import React from "react";
import { Helmet } from "react-helmet";
import '../../styles/lyrics.css';

const GodsWork = () => {
  return (
    <div>
      <Helmet>
        <title>LYRICS - GOD'S WORK</title>
      </Helmet>

      <section class="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS - GOD'S WORK</p>
        <div class="lyrics-frames">
        <div class="lyrics">
                [Intro]<br/>
                Ayea<br/>
                God's Work<br/>
                It is all God's Work<br/>
                Yeah<br/>
                Huh<br/>
                <br/>
                [Verse 1]<br/>
                They sirf mai aur varun aur swapnil<br/>
                They aate milne wo gharpe<br/>
                They sapne jo poore karne<br/>
                Aaj aur hum milne ko tarse<br/>
                Ab waise ghar se nikalke hai jaise beet gaye arse<br/>
                Par<br/>
                Maa kasam in dono ke bohot ehsaan mujhpe<br/>
                Un ne diya daga, in daali jaan mujhme<br/>
                Paved the way for this thing I liked<br/>
                It's safe to say y'all brothers really changed my life I swear<br/>
                Saale views pe nicha dikhaate aaj bhi<br/>
                Aur inke views se kabhi aate ye baaz nai<br/>
                Kya tere views jab likhe lage wo khaas nai<br/>
                Hai tere views par likhega aakhri saas nai<br/>
                Hai shuruwaat kaise millions me khele<br/>
                Ye chahe kuchalna kisi kamal ko khilne se pehele<br/>
                A few months in now, what's more for me?<br/>
                Can't complain, Labels call by my 4th release<br/>
                Been Hungry, need a break like Recess<br/>
                New School Indie, yeah/India this Music needs Reset<br/>
                Losing principles/principals, I swear it's getting difficult<br/>
                From a different school and I ain't paid my fees yet<br/>
                Which means the CHANGE is long overdue<br/>
                Make wrists bleed with pain in my own vocal booth<br/>
                Hate it or Love it can't despite the truth<br/>
                Take The Game in my hand like Raftaar's Tattoo<br/>
                I followed passion this sincerely<br/>
                Married to the game, bachelors se pehele<br/>
                Going loco with this shit<br/>
                And it won't even exist without notion on the mix<br/>
                Doesn't matter what you say fam<br/>
                Made it out my place and still with the same gang<br/>
                Pray to GAUSH<br/>
                Amen<br/>
                GAUSH is God's work, Made man<br/>
                <br/>
                [Bridge]<br/>
                Yeah<br/>
                Amen<br/>
                Made Man<br/>
                God's Work<br/>
                Pray to God<br/>
                <br/>
                [Verse 2]<br/>
                Lord forgive me for all my sins<br/>
                When it's time for me to leave it all<br/>
                GAUSH remains, Gauresh ends<br/>
                Episodes of my life and shit<br/>
                Wrote it all when I was going through it<br/>
                Gave the game everything I had<br/>
                Ain't no lie, I put my soul into it<br/>
                I just hope that I make it out<br/>
                Ain't nobody gon' get it for me<br/>
                Either Make it or Die trying<br/>
                I hope I live to tell a better story<br/>
                Worship myself when I Pray to God<br/>
                Lord forgive me for all my sins<br/>
                When it's time for me to leave it all<br/>
                GAUSH remains, Gauresh ends<br/>
                Episodes of my life and shit<br/>
                Wrote it all when I was going through it<br/>
                Gave the game everything I had<br/>
                Ain't no lie, I put my soul into it<br/>
                I just hope that I make it out<br/>
                Ain't nobody gon' get it for me<br/>
                Either Make it or Die trying<br/>
                I hope I live to tell a better story<br/>
                Yeah<br/>
                God's Work
            </div>
        </div>
    </section>
      

    </div>
  );
};

export default GodsWork;
